import { createContext, useContext } from 'react';
export var OnboardingContext = createContext(null);
export var useOnboarding = function () {
    var context = useContext(OnboardingContext);
    if (!context) {
        throw new Error('useOnboarding must be used within OnboardingProvider');
    }
    return context;
};
